import type { TranslationKeys } from '../assets/locales'
import { translationsByLanguage } from '../assets/locales'
//TODO: Consider async import instead

const englishTranslations = translationsByLanguage.en

export interface I18nLite {
  t: (key: TranslationKeys) => string
}

export default (language: string): I18nLite => {
  const translations = translationsByLanguage[language] ?? englishTranslations

  const t = (key: TranslationKeys) => translations?.[key] ?? key

  return { t }
}
